import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { primary } from 'presentations/views/styles/color';
import {
  fontSize,
  fontWeight,
  isMediaMax,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';
import Image from 'presentations/views/components/atoms/Image';
import Icon from 'presentations/views/components/atoms/Icon';

export default function Component() {
  const t = translateInComponent(translations);
  const isMobile = isMediaMax('tablet');
  return (
    <Content>
      <MainIcon
        src="pages/features/mv.png"
        width={600}
        height={400}
        alt={t('title')}
        dpr={2}
      />
      <MainContent>
        <TitleContainer>
          <IconContainer>
            <TitleIcon name="settings" size={isMobile ? '28px' : '36px'} />
          </IconContainer>
          <Title>{t('title')}</Title>
        </TitleContainer>
        <Description>{t('description')}</Description>
      </MainContent>
    </Content>
  );
}

const Content = styled.div`
  display: flex;
  ${mediaMax.tablet} {
    display: block;
    text-align: center;
  }
`;
const MainIcon = styled(Image)`
  /* box-shadow: 0px 10px 30px rgba(102, 102, 102, 0.15); */
  height: auto;
  ${mediaMax.desktop} {
    max-width: 480px;
  }
  ${mediaMax.tablet} {
    margin: ${spacing(16)} 0 ${spacing(8)};
    width: 100%;
  }
`;
const MainContent = styled.div`
  margin-left: ${spacing(40)};
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mediaMax.tablet} {
    margin-left: 0;
    margin-right: 0;
    text-align: center;
  }
`;
const TitleContainer = styled.div`
  display: flex;
  margin-bottom: ${spacing(16)};
  align-items: center;
`;
const Title = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(32)};
  ${mediaMax.tablet} {
    text-align: left;
    font-size: ${fontSize(18)};
  }
`;
const TitleIcon = styled(Icon)`
  color: ${primary};
`;
const Description = styled.div`
  white-space: pre-wrap;
  ${mediaMax.tablet} {
    text-align: left;
  }
`;
const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
  margin-right: ${spacing(8)};
  ${mediaMax.tablet} {
    width: 20px;
    height: 20px;
  }
`;
